import { combineReducers } from "redux";

import Login from "./Login/login";
import SellerDashboard from "./SellerDashBoard/selleDashBoard";
import Timer from "./Timer/Timer";
import cartReducer from "./Cart/cart";
import auctionReducer from "./Auction/auction";
export default combineReducers({
  Login: Login,
  SellerDashboard: SellerDashboard,
  Timer,
  cart: cartReducer,
  auction: auctionReducer,
});
